// extracted by mini-css-extract-plugin
export default {"popover":"popover_popover__98GXT","MuiPopover-paper":"popover_MuiPopover-paper__ak9M+","text":"popover_text__r6lJI"};